export const UserStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
  BLOCKED_DUE_TO_PAYMENT: 'BLOCKED_DUE_TO_PAYMENT',
};
